'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $is_Lapp_data_AppAuthData$Impersonating(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_data_AppAuthData$Impersonating)));
}
export { $is_Lapp_data_AppAuthData$Impersonating as $is_Lapp_data_AppAuthData$Impersonating };
function $isArrayOf_Lapp_data_AppAuthData$Impersonating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_AppAuthData$Impersonating)));
}
export { $isArrayOf_Lapp_data_AppAuthData$Impersonating as $isArrayOf_Lapp_data_AppAuthData$Impersonating };
//# sourceMappingURL=app.data.-App-Auth-Data$-Impersonating.js.map
